import axios from "../utils/axios";

export type GoodsInLot = {
  id: string;
  productId: string;
  qtyReceived: number;
  qtyRemaining: number;
  batchNumber?: string;
  expiryDate?: string;
  purchaseOrder?: { poNumber?: string };
};

export class GoodsInService {
  getAvailableLots(productId: string) {
    return axios.get<GoodsInLot[]>(
      `/stock/goods-in/available-lots/${encodeURIComponent(productId)}`,
    );
  }
}
